import { getSelectStationArray } from "./methods/getSelectStationArray";

export default {
  getSelectStationArray,
};
